/* ADD Knowledge categories */
export const PROGRESS_LESSON = "PROGRESS_LESSON"
export const PROGRESS_LESSON_SUCCESS = "PROGRESS_LESSON_SUCCESS"
export const PROGRESS_LESSON_CLEAN = "PROGRESS_LESSON_CLEAN"
export const PROGRESS_LESSON_ERROR = "PROGRESS_LESSON_ERROR"
